import { Package } from "@phosphor-icons/react";

export default function EmptyState({ icon: Icon = Package, title, message, action, testId }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white px-6 py-16 text-center"
    >
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400">
        <Icon size={28} weight="duotone" />
      </div>
      <h3 className="font-display text-lg font-bold text-slate-800">{title}</h3>
      {message && <p className="mt-1 max-w-sm text-sm text-slate-500">{message}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
